/**
 * Close Icon - X button icon for HALO components
 *
 * Design: 16x16 X/cross shape
 * Usage: Close functionality in buttons, modals, dialogs
 * Color: #2F3C53 for good contrast on light backgrounds
 */

export const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.61717 8L15.8726 0.744991C16.0425 0.575106 16.0425 0.298171 15.8726 0.128286C15.7015 -0.0427621 15.4257 -0.0427621 15.2558 0.128286L8.00044 7.38329L0.745032 0.128286C0.573974 -0.0427621 0.298187 -0.0427621 0.128293 0.128286C-0.0427644 0.298171 -0.0427644 0.575106 0.128293 0.744991L7.38253 8L0.128293 15.255C-0.0427644 15.4249 -0.0427644 15.7018 0.128293 15.8717C0.298187 16.0428 0.573974 16.0428 0.745032 15.8717L8.00044 8.6167L15.2558 15.8717C15.4257 16.0428 15.7015 16.0428 15.8726 15.8717C16.0425 15.7018 16.0425 15.4249 15.8726 15.255L8.61717 8Z"
      fill="#2F3C53"
    />
  </svg>
);
